import React from 'react'
import { Link } from 'react-router-dom'
import Taste from './../assets/icons/taste.png'
import Quality from './../assets/icons/Quality.png'
import Service from './../assets/icons/Service Execellence.png'
import Value from './../assets/icons/value.png'
import WeddingCatering from './../assets/gallery/Wedding catering.jpg'
import CorporateCatering from './../assets/gallery/Corporate catering.jpg';
import SocialEventsCatering from './../assets/gallery/Social events.jpg';
import CuisineEleganceImg from './../assets/gallery/cuisine_elegance.png';
import HostingHarmonyImg from './../assets/gallery/hosting_harmony.png';
import DreamyCelebrationsImg from './../assets/gallery/dreamy_celebrations.png';
import StarsImg from './../assets/icons/stars.png';
import Navbar from './Navbar'
import './css/BestCatering.css'

function BestCateringPage() {
  return (
    <div>
      <div className='HomeHero custom'>
        <div className=''></div>
        <Navbar className='navbar' />
        <div className='content'>
          <div className='left'>
            <p className='welcome'>Professional work</p>
            {/* <img className='logo' src={Logo} alt='Logo' /> */}
            <h1 className='heading1'>Unveiling the Best catering Services in Kochi <br />for your special Occasions</h1>
            <p className='mt-1'>Culinary Bliss Guaranteed</p>
            <Link to="/contact" target='_blank'><button className='btn-maroon'>Contact Us</button></Link>
          </div>
        </div>
      </div>
      <div className='container mb-4 web-mobile'>
        <div className='col text-center mb-5'>
          <h2>Your Smiles Drive Us</h2>
          <h5>Celebrating Success in Your Happiness. </h5>
        </div>
        <div className='row'>
          <div className='col-lg-3 col-md-6 col-sm-6 col-6'>
            <div className="card bg-maroon mb-2">
              <div className="card-body text-center">
                <img src={Taste} className="card-img-top img-fluid w-50" alt='best catering services in Kochi' />
                <p className="card-text text-white">Good Taste </p>
              </div>
            </div>
          </div>
          <div className='col-lg-3 col-md-6 col-sm-6 col-6'>
            <div className="card bg-maroon mb-2">
              <div className="card-body text-center">
                <img src={Quality} className="card-img-top img-fluid w-50" alt='best catering services in Kochi' />
                <p className="card-text text-white">Best Quality</p>
              </div>
            </div>
          </div>
          <div className='col-lg-3 col-md-6 col-sm-6 col-6'>
            <div className="card bg-maroon mb-2">
              <div className="card-body text-center">
                <img src={Service} className="card-img-top img-fluid w-50" alt='best catering services in Kochi' />
                <p className="card-text text-white">
                  <span className='d-sm-block d-xs-block d-lg-none'>Excellent Service</span>
                  <span className='d-none d-lg-block'>Service Execellence</span></p>
              </div>
            </div>
          </div>
          <div className='col-lg-3 col-md-6 col-sm-6 col-6'>
            <div className="card bg-maroon mb-2">
              <div className="card-body text-center">
                <img src={Value} className="card-img-top img-fluid w-50" alt='best catering services in Kochi' />
                <p className="card-text text-white">Value For Money</p>
              </div>
            </div>
          </div>
        </div>
        {/* Content 2 */}
        <div className='pt-5'>
          <h3 className='text-center mt-3 mb-2'><b>Taste, Tradition, & Beyond</b></h3>
          <h5 className='text-center mb-5'>Plaza Catering, the best catering services in Kochi</h5>
          <p className='text-align-justify'>
            Plaza Catering is dedicated to delivering culinary experiences for every type of event. Whether you're hosting a
            get together or a large celebration our catering services in Kochi, Ernakulam and Thrissur is designed to make
            your guests experience truly unforgettable. Whether it's a birthday bash, anniversary soirée or corporate
            function our team of chefs and event coordinators will work closely with you to design a personalized menu and
            create an atmosphere that perfectly matches the significance of your special moments.
          </p>
        </div>

        {/* Content 3 */}
        <div className='row mt-3'>
          <div className='col-12 col-md-12 col-lg-6'>
            <h2 className='mt-5 mb-3 c-maroon'><b>Wedding catering</b></h2>
            <h5 className='mb-3 fw-bold'>Celebrating love with extraordinary culinary delights</h5>
            <p className='text-align-justify'>
              Your special day deserves the finest and Plaza Catering is here to
              provide exceptional culinary delights that will take your celebration
              to new heights. Our wedding catering services in Kochi offers a
              variety of cuisines, impeccable service and meticulous attention to
              every detail. With our expertise your wedding banquet will be a
              fusion of Flavors creating cherished memories, for you and your
              guests on this momentous occasion.
            </p>
            <div className='row'>
              <div className='col'>
                <div className='d-flex py-2'>
                  <span className="material-symbols-outlined pe-1">
                    done_all
                  </span>
                  Elegance & Extravagance
                </div>
                <div className='d-flex py-2'>
                  <span className="material-symbols-outlined pe-1">
                    done_all
                  </span>
                  Personalized Menus
                </div>
              </div>
              <div className='col'>
                <div className='d-flex py-2'>
                  <span className="material-symbols-outlined pe-1">
                    done_all
                  </span>
                  Impeccable Service
                </div>
                <div className='d-flex py-2'>
                  <span className="material-symbols-outlined pe-1">
                    done_all
                  </span>
                  Stunning Presentations
                </div>
              </div>
            </div>
          </div>
          <div className='col-12 col-md-12 col-lg-6'>
            <img src={WeddingCatering} className="card-img-top img-fluid" alt='best catering services in Kochi' />
          </div>
        </div>

        {/* Content 4 */}
        <div className='row mt-3'>
          <div className='col-12 col-md-12 col-lg-6 d-none d-lg-block'>
            <img src={CorporateCatering} className="card-img-top img-fluid" alt='best catering services in Kochi' />
          </div>
          <div className='col-12 col-md-12 col-lg-6'>
            <h2 className='mt-5 mb-3 c-maroon'><b>Corporate Catering</b></h2>
            <h5 className='mb-3 fw-bold'>Impress your guests with gourmet experiences</h5>
            <p className='text-align-justify'>
              Impress your clients and colleagues with our top notch gourmet
              catering services designed specifically for events. <a href='/' target='_blank' rel='noreferrer'>Plaza Catering</a> in
              Kochi guarantees that your corporate gatherings in Kochi will be a
              fusion of elegance and culinary mastery. Our curated menus and
              exceptional service will create the ideal ambiance, for prosperous
              business occasions.
            </p>
            <div className='row'>
              <div className='col'>
                <div className='d-flex py-2'>
                  <span className="material-symbols-outlined pe-1">
                    done_all
                  </span>
                  Professional Excellence
                </div>
                <div className='d-flex py-2'>
                  <span className="material-symbols-outlined pe-1">
                    done_all
                  </span>
                  Customized Packages
                </div>
              </div>
              <div className='col'>
                <div className='d-flex py-2'>
                  <span className="material-symbols-outlined pe-1">
                    done_all
                  </span>
                  Seamless Execution
                </div>
                <div className='d-flex py-2'>
                  <span className="material-symbols-outlined pe-1">
                    done_all
                  </span>
                  Good Diverse Menus
                </div>
              </div>
            </div>
          </div>
          <div className='col-12 col-md-12 col-lg-6 d-sm-block d-xs-block d-lg-none'>
            <img src={CorporateCatering} className="card-img-top img-fluid" alt='best catering services in Kochi' />
          </div>
        </div>

        {/* Content 5 */}
        <div className='row mt-3'>
          <div className='col-12 col-md-12 col-lg-6'>
            <h2 className='mt-5 mb-3 c-maroon'><b>Social Events</b></h2>
            <h5 className='mb-3 fw-bold'>Turning memorable moments into extraordinary experiences</h5>
            <p className='text-align-justify'>
              At Plaza Catering, we believe that every celebration should be
              unforgettable. Our <a href='https://catererinkochi.blogspot.com/' target='_blank' rel='noreferrer'>catering service in Kochi</a> brings life to your parties
              and celebrations with our exquisite culinary creations and
              impeccable presentation. Whether it's a family reunion, anniversary
              party, or festival celebration, our team adds the perfect flavour to
              your special moments.
            </p>
            <div className='row'>
              <div className='col'>
                <div className='d-flex py-2'>
                  <span className="material-symbols-outlined pe-1">
                    done_all
                  </span>
                  Joyful Celebrations
                </div>
                <div className='d-flex py-2'>
                  <span className="material-symbols-outlined pe-1">
                    done_all
                  </span>
                  Creative Themes
                </div>
              </div>
              <div className='col'>
                <div className='d-flex py-2'>
                  <span className="material-symbols-outlined pe-1">
                    done_all
                  </span>
                  Very Friendly Staff
                </div>
                <div className='d-flex py-2'>
                  <span className="material-symbols-outlined pe-1">
                    done_all
                  </span>
                  Versatile Venues
                </div>
              </div>
            </div>
          </div>
          <div className='col-12 col-md-12 col-lg-6'>
            <img src={SocialEventsCatering} className="card-img-top img-fluid" alt='best catering services in Kochi' />
          </div>
        </div>

        {/* Content 6 maroon */}
        <div className="card mt-5 bg-maroon rounded-0">
          <div className="card-body p-5 m-lg-3">
            <h4 className='mb-5 mt-3 text-center'>Why Plaza catering is the best catering company in Kochi?</h4>
            <div className='row'>
              <div className='col'>
                <div className='d-flex mb-3'>
                  <span className="material-symbols-sharp me-3 fs-1">arrow_circle_right</span>
                  <div className="text-start">
                    <h5>Exquisite Culinary Artistry</h5>
                    <small>Masterful chefs craft exceptional Flavors and presentations</small>
                  </div>
                </div>
              </div>
              <div className='col'>
                <div className='d-flex mb-3'>
                  <span className="material-symbols-sharp me-3 fs-1">arrow_circle_right</span>
                  <div className="text-start">
                    <h5>Premium Quality Ingredients </h5>
                    <small>Fresh, finest ingredients sourced for delectable delicacies</small>
                  </div>
                </div>
              </div>
            </div>
            <div className='row'>
              <div className='col'>
                <div className='d-flex mb-3'>
                  <span className="material-symbols-sharp me-3 fs-1">arrow_circle_right</span>
                  <div className="text-start">
                    <h5>Unparalleled Service Excellence</h5>
                    <small>Impeccable service, exceeding expectations, and personalized attention </small>
                  </div>
                </div>
              </div>
              <div className='col'>
                <div className='d-flex mb-3'>
                  <span className="material-symbols-sharp me-3 fs-1">arrow_circle_right</span>
                  <div className="text-start">
                    <h5>Innovative Flair Unleashed</h5>
                    <small>Boldly creative presentations that captivate and innovate</small>
                  </div>
                </div>
              </div>
            </div>
            <div className='row'>
              <div className='col'>
                <div className='d-flex mb-3'>
                  <span className="material-symbols-sharp me-3 fs-1">arrow_circle_right</span>
                  <div className="text-start">
                    <h5>Diverse Menu Perfection</h5>
                    <small>Extensive, diverse menus for all occasions, surpassing expectations</small>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>

        {/* Content 7 */}
        <div className='pt-5'>
          <h3 className='text-center mt-3'><b>Taste the Unparalleled</b></h3>
          <h5 className='text-center mb-3'>Plaza Catering Shines as Kerala s Extravagant Choice</h5>
          <p className='text-align-justify'>
            Savor the culinary fusion at Plaza Catering, where the timeless flavours of Kerala seamlessly merge with international cuisine. Embark, on a
            gastronomic adventure that celebrates the diverse heritage of Kerala’s traditional dishes infused with global culinary inspirations.
          </p>
          <div className='row'>
            <div className='col-12 col-md-12 col-lg-4 mb-3'>
              <a href='https://plazacatering.co.in/' target='_blank' rel='noreferrer'>
                <img src={CuisineEleganceImg} className='img-fluid' alt='best catering services in Kochi' />
              </a>
            </div>
            <div className='col-12 col-md-12 col-lg-4 mb-3'>
              <a href='https://plazacatering.co.in/services' target='_blank' rel='noreferrer'>
                <img src={HostingHarmonyImg} className='img-fluid' alt='best catering services in Kochi' />
              </a>
            </div>
            <div className='col-12 col-md-12 col-lg-4 mb-3'>
              <a href='https://plazacatering.co.in/gallery' target='_blank' rel='noreferrer'>
                <img src={DreamyCelebrationsImg} className='img-fluid' alt='best catering services in Kochi' />
              </a>
            </div>
          </div>
        </div>

        {/* Reviews 8 */}
        <div className='pt-5'>
          <h3 className='text-center my-3'><b>Google Review</b></h3>
          <div className='row'>
            <div className='col-12 col-md-12 col-lg-4 mb-2'>
              <div className="card rounded-0 m-4 border border-0">
                <div className="card-body bg-light  h-100">
                  <div className='text-center mb-3'>
                    <img src={StarsImg} className='img-fluid w-5' alt='best catering services in Kochi' />
                  </div>
                  <div className='text-align-justify'>
                    "Thank you and your team for the
                    incredible catering at the reception. We
                    were so pleased with the presentation of
                    the meal and the exemplary service of all
                    your staff. Everyone commented on how
                    delicious and sophisticated the items
                    were. We feel so fortunate to have had the
                    opportunity to work with you. We
                    appreciate everything you and your staff
                    did" </div>
                  <br />
                  <h6><b>Sneha Anna</b></h6>
                </div>
              </div>
            </div>
            <div className='col-12 col-md-12 col-lg-8 mb-2'>
              <div className='row'>
                <div className='col-12 col-md-12 col-lg-12'>
                  <div className="card rounded-0 m-4 border border-0">
                    <div className="card-body bg-light h-100">
                      <div className='text-center mb-2'>
                        <img src={StarsImg} className='img-fluid w-5' alt='best catering services in Kochi' />
                      </div>
                      <div className='text-align-justify'>
                        "We had hired Plaza caterers for our reception function and had a great experience with
                        them. The food served was yummy and the staff were very active to ensure a pleasant buffet
                        experience. They ensure that everyone is attended and served food with love. The Salads and
                        Variety Teas was like icing on cake and everyone enjoyed them. I highly recommend Plaza
                        caterers for their taste of food and politeness of their owner Mr.Irash & Son" </div>
                      <br />
                      <h6><b>Kiran Chand C S</b></h6>
                    </div>
                  </div>
                </div>
                <div className='col-12 col-md-12 col-lg-12'>
                  <div className="card rounded-0 m-4 border border-0">
                    <div className="card-body bg-light">
                      <div className='text-center mb-2'>
                        <img src={StarsImg} className='img-fluid w-5' alt='best catering services in Kochi' />
                      </div>
                      <div className='text-align-justify'>
                        "Just attended my cousin in laws Mehendi Function and Plaza Catering provided the food. It was
                        excellent. I loved the bun parotta and the mutton curry. I hope my other family members use
                        their catering for future events. Their food is delicious." </div>
                      <br />
                      <h6><b>Adam Walker</b></h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  )
}

export default BestCateringPage